import { Box, Flex, Icon, VStack } from "@chakra-ui/react"
import { BsFillShieldLockFill } from "react-icons/bs"
import { FaHandHoldingUsd, FaShippingFast } from "react-icons/fa"
import { GiReturnArrow } from "react-icons/gi"

const GZBFeatures = () => {
  return (
    <Flex
      width={"full"}
      justifyContent={"space-evenly"}
      alignItems={"flex-start"}
      flexWrap={"wrap"}
    >
      <VStack
        spacing={6}
        width={"25%"}
        textAlign={"center"}
      >
        <Icon
          as={FaShippingFast}
          w={10}
          h={10}
        />
        <Box fontSize={"xs"}>{"Free Delivery"}</Box>
      </VStack>
      <VStack
        spacing={6}
        width={"25%"}
        textAlign={"center"}
      >
        <Icon
          as={FaHandHoldingUsd}
          w={10}
          h={10}
        />
        <Box fontSize={"xs"}>{"Cash on Delivery"}</Box>
      </VStack>

      <VStack
        spacing={6}
        width={"25%"}
        textAlign={"center"}
      >
        <Icon
          as={GiReturnArrow}
          w={10}
          h={10}
        />
        <Box fontSize={"xs"}>
          <Box>{"15 Days"}</Box>
          <Box>{"Free Returns"}</Box>
        </Box>
      </VStack>

      <VStack
        spacing={6}
        width={"25%"}
        textAlign={"center"}
      >
        <Icon
          as={BsFillShieldLockFill}
          w={10}
          h={10}
        />
        <Box fontSize={"xs"}>{"Secure Checkout"}</Box>
      </VStack>
    </Flex>
  )
}

export default GZBFeatures
